module.exports = __webpack_public_path__ + "media/assets/site_images/field_sunrise-bc599579a0d40af87b9d6b3e8f50e50e.jpg";